import React from "react";
import { localize } from "src/l10n";
import { SpintrUser, UnstyledButton } from "src/ui";
import { IShareTarget } from "./ShareModal.types";
import { shareTargetConfig } from "./shareTargetConfig";

interface IProps {
    target: IShareTarget;
    onSelect: (target: IShareTarget) => void;
}

const ShareTargetItem = (props: IProps) => {
    const { target } = props;
    const config = shareTargetConfig[target.type];

    const subText = target.disabled
        ? localize(target.disabledReasonKey || "SHARE_DISABLED_GROUP_NO_CHAT")
        : localize(config.descriptionKey);

    return (
        <UnstyledButton
            className={"ShareTargetItem"
                + (target.disabled ? " disabled" : "")
                + (target.type === "feed" ? " ShareTargetItem--feed" : "")}
            disabled={target.disabled}
            title={target.disabled ? subText : target.name}
            onClick={() => {
                if (target.disabled) {
                    return;
                }

                props.onSelect(target);
            }}
        >
            <SpintrUser
                name={target.name}
                subText={subText}
                imageUrl={target.imageUrl}
                iconToDisplayInsteadOfInitials={!target.imageUrl ? config.iconName : undefined}
                personalName={target.type === "user"}
            />
        </UnstyledButton>
    );
};

export default ShareTargetItem;
